import * as React from "react"
import { hydrate, render } from "react-dom"
import { reportWebVitals } from "./scripts/WebVitals"
import App from "./components/App/App"

const rootElement = document.getElementById("root")
const indexElement = <>
  <React.StrictMode>
    <App />
  </React.StrictMode>
</>

if (rootElement.hasChildNodes()) {
  hydrate(indexElement, rootElement)
} else {
  render(indexElement, rootElement)
}

reportWebVitals()